import React from 'react'
import { Segment, Form, Tab, Menu } from 'semantic-ui-react'
import { Column, Table } from 'react-virtualized'
import 'react-virtualized/styles.css'
import moment from 'moment'
import ModalWrapper from '../components/ModalWrapper'
import TagTypeForm from '../containers/TagTypeForm'
import {isEqual} from 'lodash'
import { Link } from 'react-router-dom'

export default class TagTypesList extends React.Component {
  width = 1550
  height = 700
  headerHeight = 40
  overscanRowCount = 2
  rowHeight = 40

  constructor(props) {
    super(props);
    this.state = {
      categories: undefined,
      currentRowData: undefined,
      filterData: {}
    };
  }

  componentDidMount() {
    this.props.loadTagTypes()
  }

  componentDidUpdate() {
    if (!isEqual(this.props.tagTypes, this.state.tagTypes)) {
      this.setState({
        tagTypes: this.props.tagTypes
      })
    }
  }

  rowGetter  = ({index}) => {
    return this.state.tagTypes[index]
  }

  timeCellRenderer = ({cellData}) =>  moment(cellData).format('DD/MM/YYYY HH:mm:ss')
  tableHeaderRenderer = ({className, columns, style}) => {
    return (<div className={className} role="row" style={style}>
      {columns}
    </div>)
  }

  onRowClick = ({rowData}) => {

    this.setState({
      modalOpen: true,
      currentRowData: rowData
    })
  }

  closeModal = () => {
    this.setState({
      modalOpen: false
    })
  }

  onChangeShowDeleted = (event, {checked}) => {
    let filterData = {...this.state.filterData, showDeleted: checked}
    this.setState({
      filterData
    })
    this.props.onFilterChange && this.props.onFilterChange(filterData)
    this.props.loadTagTypes(filterData)
  }

  panes = [
    {
      menuItem: (
        <Menu.Item
          key="tagsMenuItem"
          as={Link}
          to="/admin/tags"
          name="tags">
        </Menu.Item>
      )
    },
    {
      menuItem: 'Tag Types',
      render: () => (
        <Tab.Pane>
        <Form>
          <Form.Checkbox toggle onChange={this.onChangeShowDeleted} label='Include deleted' />
        </Form>
        <ModalWrapper headerIcon='edit' headerContent='Edit tag' onClose={this.closeModal} open={this.state.modalOpen} render={
          (close) => (
            <TagTypeForm onSuccess={() => {
              this.closeModal()
              this.props.loadTagTypes(this.state.filterData)
            }} editMode={true} data={this.state.currentRowData}/>
          )
        }/>
        {this.state.tagTypes ? <Table
          headerRowRenderer={this.tableHeaderRenderer}
          ref="Table"
          headerHeight={this.headerHeight}
          height={this.height}
          overscanRowCount={this.overscanRowCount}
          rowHeight={this.rowHeight}
          rowGetter={this.rowGetter}
          rowCount={this.state.tagTypes.length}
          onRowClick={this.onRowClick}
          rowClassName={'tableRow'}
          gridClassName={'tableGrid'}
          width={this.width}>
          <Column
            label="ID"
            dataKey="id"
            width={60}
          />
          <Column
            label="Name"
            dataKey="name"
            width={200}
          />
          <Column
            label="Created"
            dataKey="createdAt"
            width={200}
            cellRenderer={this.timeCellRenderer}
          />
          <Column
            label="Updated"
            dataKey="updatedAt"
            width={200}
            cellRenderer={this.timeCellRenderer}
          />
        </Table> : null}
        </Tab.Pane>
      )
    }
  ]

  render() {
    return (
      <Segment compact={true} basic={true} loading={this.props.loading}>
      <Tab activeIndex={1} panes={this.panes} />

      </Segment>
    )
  }
}
